module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av324-78abf6a815c8bcda9f3c02e1020ae24e.jpg";